<template>
    <div>
        <meta
            og:image="https://u-money.mn/images/72b63dec-467f-4458-907c-2d20ce6596ab.JPG"
        />
        <div class="article__header columns">
            <h3 class="pageTitle">{{ pageData.contents[0].title }}</h3>

            <div class="article__date column col-sm-12 col-md-3 col-2">
                <p class="size-2 my-2 article-pdate">
                    <i class="fas fa-calendar-alt"></i>
                    {{ pageData.publishDate }}
                </p>
            </div>
        </div>

        <div class="ql-editor p-0">
            <div class="article__body" v-html="pageData.contents[0].body"></div>
        </div>

        <div class="article__footer">
            <div class="article__share">
                <a
                    :href="
                        'https://www.facebook.com/sharer/sharer.php?u=' +
                        fullPath
                    "
                    class="article__share-btn mx-2"
                    target="_blank"
                >
                    <i class="fab fa-facebook-f"></i>
                </a>
                <a
                    :href="'https://twitter.com/home?status=' + fullPath"
                    class="article__share-btn mx-2"
                >
                    <i class="fab fa-twitter"></i>
                </a>
            </div>

            <div class="article__nav">
                <router-link
                    v-if="pageData.prevContentURL"
                    :to="pageData.prevContentURL"
                    class="label px-2 nav__prev"
                    >{{ getCaption("caption.previous_button") }}</router-link
                >
                <router-link
                    v-if="pageData.nextContentURL"
                    :to="pageData.nextContentURL"
                    class="label px-2 nav__next"
                    >{{ getCaption("caption.next_button") }}</router-link
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["pageData"],

    computed: {
        fullPath() {
            return window.location.origin + this.$route.fullPath;
        },
    },

    created() {
        this.$store.dispatch("setHasBreadcrumb", false);
    },
};
</script>

<style src="@/assets/css/quill.snow.css"></style>
<style lang="scss">
.article__body {
    ul,
    ol {
        line-height: 1em;
    }
}
</style>
<style lang="scss" scoped>
.article__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.article__title {
    margin: 0.5em 0;
}

.article__date {
    text-align: right;
}
.article-pdate {
    color: #777;
}

.article__footer {
    clear: both;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1em 0 0;
}

.article__share {
    display: none;
}

.article__share-btn {
    background: rgba(0, 0, 0, 0.35);
    padding: 0.6em 0.9em;
    border-radius: 9999px;
    width: 37px;
    height: 37px;
    text-align: center;
    color: white;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s;

    &:hover {
        background: rgba(0, 0, 0, 0.45);
    }
}

.article__nav {
    display: flex;
    justify-content: space-around;
    width: 100%;
}
.article__footer .article__nav > a.label {
    background-color: #767676;
    color: #fff;
    border-radius: 0;
    -webkit-border-radius: 0;
    margin: 0 1px;
}

.article__footer .article__nav > a.label.nav__prev {
    -webkit-border-top-left-radius: 12px;
    -webkit-border-bottom-left-radius: 12px;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    padding-left: 12px !important;
}
.article__footer .article__nav > a.nav__next {
    -webkit-border-top-right-radius: 12px;
    -webkit-border-bottom-right-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    padding-right: 12px !important;
}
.article__footer .article__nav > a.label:hover {
    background-color: $orange-color;
}

@media (min-width: $breakpoint-md) {
    .article__date {
        display: block;
    }

    .article__share {
        display: flex;
    }

    .article__nav {
        width: auto;
    }
}
</style>
